export enum ProductEnum {
	GO = 1,
}
